import(/* webpackMode: "eager" */ "/home/runner/work/psx-frontend/psx-frontend/app/market-overview/error.tsx");
